export const HomeTab = (authenticatedResources) => (
  <div className="flex-grow px-4 py-5 sm:p-6 overflow-y-scroll flex flex-row">
    <div className="flex-grow">
      <h1 className="text-gray-700 text-2xl font-bold p-2 items-center">
        Digital Portfolio{" "}
        <a href="https://www.linkedin.com/in/luca-dovichi/">
          <i className="fa fa-linkedin-square text-2xl text-blue-600 pl-2" />
        </a>
      </h1>
      <h2 className="text-gray-700 text-xl p-2">
        I'm Luca Dovichi, a CS undergrad at the University of Chicago (BS '27).
        I was a research assistant in Prof. Blase Ur's{" "}
        <a
          href="https://super.cs.uchicago.edu/"
          className="text-blue-600"
          target="_blank"
        >
          SUPERgroup
        </a>{" "}
        for four years, and I have industry experience at{" "}
        <strong> GridLink</strong> ('24, '25), <strong>NetMicroscope</strong>{" "}
        ('25), and <strong>SpaceX</strong> ('26). I also will be interning with{" "}
        <strong>Citadel Securities</strong> this summer.
      </h2>
      <img
        src={authenticatedResources.headshot}
        className="w-auto mx-auto sm:w-0 h-48 py-2 rounded-[2rem]"
      />
    </div>
    <img
      src={authenticatedResources.headshot}
      className="sm:inline-block hidden sm:w-auto h-64 p-8 rounded-[4rem]"
    />
  </div>
);
